import { wceApi } from '@/api';

export type Elements = Record<string, unknown>;

export type Background = {
  type: string;
  value: string;
};

export type PageWidth = 'narrow' | 'regular' | 'wide';

export const updatePageContents = (
  data: {
    background: Background;
    elements: Elements;
    id: string;
    pageWidth: PageWidth;
    sectionIds: string[];
  },
  cb: () => void,
  silent: boolean
) => {
  wceApi.post(`/design/contents/${data.id}`, {
    content: JSON.stringify(data),
  })
    .then(() => {
      if (!silent) {
        alert('저장되었습니다.');
      }
      cb();
    });
};

type GetDesignContentsPageIdHistoriesResponse = {
  metaNo: string;
  timestamp: unknown;
}[];

export const fetchPageHistoryList = (
  pageId: string,
  cb: (
    result: {
      id: string;
      timestamp: number;
    }[]
  ) => void
) => {
  wceApi.get<GetDesignContentsPageIdHistoriesResponse>(`/design/contents/${pageId}/histories`)
    .then(({ data }) => {
      cb(
        data.map(({ metaNo, timestamp }) => ({
          id: metaNo,
          // TODO: timestamp 타입 확인 후 Number 벗겨내기
          timestamp: Number(timestamp),
        }))
      );
    });
};

export type ElementTypeName = CommonElementTypeName | 'section' | 'column';

export type CommonElementTypeName =
  | 'image'
  | 'slider'
  | 'text'
  | 'button'
  | 'video'
  | 'map'
  | 'sns'
  | 'board'
  | 'product'
  | 'productSlide';

type ElementToolMenuName = 'headerCategory' | 'headerMenus' | 'headerIcons';

type DefaultToolMenu = {
  elementType?: ElementTypeName;
  selectedMenu?: ElementToolMenuName;
};

type SceneState = {
  pageId: string;
  sectionIds: string[];
  selectedElementIds: string[];
  selectCandidateElementIds: string[];
  autoOpenElementTool: DefaultToolMenu[];
  background: Background;
  pageWidth: PageWidth;
  elements: Elements;
};

type GetDesignContentsHistoriesHistoryNoResponse = {
  content: string;
};

export const fetchPageHistoryContents = (
  { id, pageId }: {
    id: number;
    pageId: string;
  },
  cb: (
    result: {
      id: number;
      pageId: string;
      timeStamp: number;
      contents: SceneState;
    }
  ) => void
) => {
  wceApi.get<GetDesignContentsHistoriesHistoryNoResponse>(`/design/contents/histories/${id}`)
    .then(({ data: { content } }) => {
      cb({
        contents: JSON.parse(content),
        pageId,
        // 실제로 쓰이지 않음
        id,
        timeStamp: 0,
      });
    });
};

export const changePageBackground = (pageId: string | null, background: Background) => {
  wceApi.put('/design/contents/changePageBackground', {
    ...background,
    pageId,
  });
};

export const changePageWidth = (pageId: number, pageWidth: number) => {
  wceApi.put('/design/contents/changePageWidth', {
    pageId,
    pageWidth,
  });
};
